import { useState, useEffect } from 'react';
import { onSnapshot, collection, query, orderBy, where } from 'firebase/firestore';
import { db, firestore } from '../firebase/firebase';

export function useSortCollection(path, filters = [], sort = []) {
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let q = collection(firestore, path);
    filters.forEach(([field, op, value]) => {
      q = query(q, where(field, op, value));
    });
    sort.forEach(([field, direction]) => {
      q = query(q, orderBy(field, direction));
    });
	
    const unsub = onSnapshot(q, snapshot => {
      setDocs(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      setLoading(false);
    });

    return () => unsub();
  }, [path, JSON.stringify(filters), JSON.stringify(sort)]);

  return { docs, loading };
}
